import { makeSelectDocumentValue } from 'services/documents/selectors';
import { selectPeopleKeyedByUserId } from 'services/people/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

const selectDocumentCreatedBy = createDeepEqualSelector(
    [makeSelectDocumentValue('createdByUserId'), selectPeopleKeyedByUserId],
    (createdByUserId, peopleKeyedByUserId) => {
        const createdBy =
            (createdByUserId &&
                peopleKeyedByUserId[createdByUserId].fullName) ||
            '';

        return createdBy;
    }
);

export { selectDocumentCreatedBy };
